import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';


import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const assignUserEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    {resourceIds?: string[], resourceQuery: string}
>('assignUserEntitlementsState', undefined);

export const assignUserEntitlementsStateActions = assignUserEntitlementsStateSlice.actions;
export const assignUserEntitlementsStateSelector:
CachedTableStateSelector<undefined, undefined, {resourceIds?: string[], resourceQuery: string}>
    = state => state.userPage.assignEntitlements.state;
